import { ObservableArray, View } from "binder"
import { SendNotificationViewModel, singleNotification } from "./sendNotification-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "../../windowContainer/IPopup";

export class SendNotificationView extends View<SendNotificationViewModel>{
    GetViewUniqueId(): string {
        return "V-1F13511E-D170-4FDE-BF01-4BBAC1054459"
    }
    loadHtml(): string {
        let element = require('./sendNotification.html').default;
        let style = require('./sendNotification.less');
        return element;
    }
    constructor() {
       super();
    }

    public set notifications(v: ObservableArray<singleNotification>) { this._notifications = v; } public get notifications(): ObservableArray<singleNotification> { return this._notifications;} private _notifications: ObservableArray<singleNotification>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    sendNotification():void{
        this.dataContext.sendNotification();
    }
}
